import { render, staticRenderFns } from "./senha-input.vue?vue&type=template&id=ba033fc6"
import script from "./senha-input.vue?vue&type=script&lang=js"
export * from "./senha-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports